function isIo9Host(host: string): boolean {
  return host.endsWith('.io9.app') || host === 'io9.app'
}

function getRuntimeHost(): string {
  if (typeof window === 'undefined') return 'iportal.io9.app'
  return window.location.host
}

function getRuntimeProtocol(): string {
  if (typeof window === 'undefined') return 'https:'
  return window.location.protocol
}

export function getIBaseURL(): string {
  const env = import.meta.env.VITE_IBASE_URL
  if (env) return env
  const host = getRuntimeHost()
  const protocol = getRuntimeProtocol()
  if (isIo9Host(host)) {
    return `${protocol}//ibase.io9.app`
  }
  return `${protocol}//${host}/ibase`
}

export function getIVPPURL(): string {
  const env = import.meta.env.VITE_IVPP_URL
  if (env) return env
  const host = getRuntimeHost()
  const protocol = getRuntimeProtocol()
  if (isIo9Host(host)) {
    return `${protocol}//ivpp.io9.app`
  }
  return `${protocol}//${host}/ivpp`
}

export function getAppURL(slug: string): string {
  const envMap: Record<string, string | undefined> = {
    ibase: import.meta.env.VITE_IBASE_URL,
    ivpp: import.meta.env.VITE_IVPP_URL,
    iportal: import.meta.env.VITE_IPORTAL_URL,
    ibao: import.meta.env.VITE_IBAO_URL,
    ibill: import.meta.env.VITE_IBILL_URL,
    idata: import.meta.env.VITE_IDATA_URL,
    icontract: import.meta.env.VITE_ICONTRACT_URL,
    ibrain: import.meta.env.VITE_IBRAIN_URL,
    iasset: import.meta.env.VITE_IASSET_URL,
    iagent: import.meta.env.VITE_IAGENT_URL,
    icity: import.meta.env.VITE_ICITY_URL,
    itown: import.meta.env.VITE_ITOWN_URL,
    isim: import.meta.env.VITE_ISIM_URL,
    iadmin: import.meta.env.VITE_IADMIN_URL,
    icert: import.meta.env.VITE_ICERT_URL,
    'big-screen': import.meta.env.VITE_BIG_SCREEN_URL,
    'iscreen': import.meta.env.VITE_ISCREEN_URL,
    'bigscreen': import.meta.env.VITE_BIGSCREEN_URL,
  }
  const env = envMap[slug]
  if (env) return env
  const host = getRuntimeHost()
  const protocol = getRuntimeProtocol()
  if (isIo9Host(host)) {
    return `${protocol}//${slug}.io9.app`
  }
  return `${protocol}//${host}/${slug}`
}

// Backward-compatible runtime constants
export const IBASE_URL = getIBaseURL()
export const IVPP_URL = getIVPPURL()
